import { TripScheduleFilters } from '../../lib/types/models/trips-schedule/trip-schedule'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

type TripScheduleIndividuals = {
  numberOfStudents: number
  numberOfStaffs: number
}

export function getTripScheduleIndividuals(filters?: TripScheduleFilters) {
  return restApiClient
    .url(
      encodeNestedObject(
        constructApiUrl(API.tripsSchedule.getTripScheduleIndividuals.url, null),
        filters
      )
    )
    .get<TripScheduleIndividuals>()
}
